import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { CgPlayStopR } from "react-icons/cg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetFoodItemsForCustomersQuery } from "../slices/FoodItemSilce";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../slices/authSlice";
import LazyMemberImage from "../components/LazyMemberImage";
import ReUsableModal from "../components/ReUsableModal";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { getNameOfTheDay } from "../utils/getCurrentDate";

const FoodsListScreen = () => {
  const { foodList } = useSelector((state) => state.foodList);
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id: outletId } = useParams();

  const [searchText, setSearchText] = useState("");
  const [foodItemsToList, setFoodItemsToList] = useState([]);
  const [selectedItems, setSelectedItems] = useState({
    ...userInfo?.selectedItems,
  });

  const [foodCategoriesToList, setfoodCategoriesToList] = useState([]);
  const [fullFoodList, setFullFoodList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All Items");
  const [itemSizes, setItemSizes] = useState({});
  const [differentSizes, setDifferentSizes] = useState();
  // const [selectedItemSize, setSelectedItemSize] = useState("");
  const [sizeClicked, setSizeClicked] = useState(false);
  const [currItem, setCurrItem] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [newOuletItem, setNewOuletItem] = useState();
  const [vegFilter, setVegFilter] = useState("All");

  const {
    data: foodItems,
    isLoading,
    error,
    refetch,
  } = useGetFoodItemsForCustomersQuery({
    query: `outletId=${outletId}&currentlySelling=true`,
  });

  const categoryRefs = useRef({});
  const scrollContainerRef = useRef(null);

  foodCategoriesToList.forEach((cat) => {
    if (!categoryRefs.current[cat]) {
      categoryRefs.current[cat] = React.createRef();
    }
  });

  const scrollToCategory = (category) => {
    if (category === "All" || category === "All Items") {
      if (scrollContainerRef.current) scrollContainerRef.current.scrollTop = 0;
    } else {
      const section = document.getElementById(`section-${category}`);
      if (section && scrollContainerRef.current) {
        scrollContainerRef.current.scrollTo({
          top: section.offsetTop - scrollContainerRef.current.offsetTop,
          behavior: "smooth",
        });
      }
    }
  };

  useEffect(() => {
    // const timer = setTimeout(() => {
    if (!isLoading && !error) {
      refetch();
      const items = isLoading ? [] : foodItems ? foodItems : [];
      const foodIds = new Set(foodList.map((f) => f?._id));
      const filterFd = items?.filter((it) => !foodIds.has(it?._id));
      setFoodItemsToList([...filterFd, ...foodList]);
      const itSizes = {};
      items?.forEach((it) => {
        itSizes[it?._id] = it?.availableSizes[0];
      });

      setItemSizes(itSizes);
      dispatch(
        setCredentials({ ...userInfo, foodList: items, itemSizes: itSizes })
      );
    }
    // }, 500);

    // return () => clearTimeout(timer);
  }, [searchText, isLoading, foodItems, foodList, refetch, error]);

  useEffect(() => {
    if (!isLoading && foodItems) {
      setFullFoodList(foodItems);
      setFoodItemsToList(foodItems);
      const categories = [
        "All",
        ...new Set(foodItems.map((item) => item.itemCategory).filter(Boolean)),
      ];
      setfoodCategoriesToList(categories);
    }
  }, [isLoading, foodItems]);

  const handleAddCheck = async (item) => {
    if (
      userInfo?.selectedItems === undefined ||
      userInfo?.selectedItems === null
    )
      await handleItemSelect(item, 0);
    else {
      const cartItemIds = new Set(
        Object.keys(userInfo?.selectedItems)?.map((ci) =>
          ci.toString().slice(0, 11)
        )
      );
      if (
        cartItemIds.size > 0 &&
        !cartItemIds.has(item._id.toString().slice(0, 11))
      ) {
        setNewOuletItem(item);
        setShowModal(true);
        return;
      } else {
        await handleItemSelect(item, 0);
      }
    }
  };

  const increaseselectedItems = async (item) => {
    await handleItemSelect(item, 1);
  };

  const decreaseselectedItems = async (item) => {
    await handleItemSelect(item, -1);
  };

  const handleItemSelect = async (item, increaseCount) => {
    let selectedItemSizes;
    selectedItemSizes = item.availableSizes.find(
      (ai) => ai.sizeName === itemSizes[item._id]?.sizeName
    );
    let getItem = selectedItems[item._id];
    const discountAmount =
      (selectedItemSizes?.itemPrice * selectedItemSizes?.discountPercent) /
        100 +
      selectedItemSizes?.discountAmount;
    const itemDetails = {
      itemId: item._id,
      itemName: item.itemName,
      itemSize: selectedItemSizes?.sizeName,
      selectedQuantity:
        (getItem?.selectedQuantity > 0 ? getItem?.selectedQuantity : 1) +
        increaseCount,
      itemOfferPrice: selectedItemSizes?.itemPrice - discountAmount,
      discountAmount: discountAmount,
      itemOriginalPrice: selectedItemSizes?.itemPrice,
      gstPercent: item.gstTax,
      totalSellingPrice:
        ((getItem?.selectedQuantity > 0 ? getItem?.selectedQuantity : 1) +
          increaseCount) *
          (selectedItemSizes.itemPrice - discountAmount) +
        (((getItem?.selectedQuantity > 0 ? getItem?.selectedQuantity : 1) +
          increaseCount) *
          (selectedItemSizes.itemPrice - discountAmount) *
          (userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0)) /
          100,

      gstTax:
        (((getItem?.selectedQuantity > 0 ? getItem?.selectedQuantity : 1) +
          increaseCount) *
          (selectedItemSizes.itemPrice - discountAmount) *
          item.gstTax) /
        100,
    };
    if (itemDetails.selectedQuantity < 1) {
      const abb = delete selectedItems[item._id];
      setSelectedItems({ ...selectedItems });
      dispatch(
        setCredentials({
          ...userInfo,
          selectedItems: { ...selectedItems },
        })
      );
    } else {
      setSelectedItems({ ...selectedItems, [item._id]: itemDetails });
      dispatch(
        setCredentials({
          ...userInfo,
          selectedItems: { ...selectedItems, [item._id]: itemDetails },
        })
      );
    }
  };

  const filteredFoods = foodItemsToList.filter((item) => {
    const name = item?.itemName?.toLowerCase() || "";
    const local = item?.localName?.toLowerCase() || "";
    const matchesSearch =
      name.includes(searchText.toLowerCase()) ||
      local.includes(searchText.toLowerCase());

    const matchesCategory =
      selectedCategory === "All" || selectedCategory === "All Items"
        ? true
        : item.itemCategory === selectedCategory;

    const matchesVegFilter =
      vegFilter === "All"
        ? true
        : vegFilter === "Veg"
        ? item.isVeg === true
        : item.isVeg === false;

    return matchesSearch && matchesCategory && matchesVegFilter;
  });

  const foodsGroupedByCategory = {};
  filteredFoods.forEach((item) => {
    const cat = item.itemCategory || "Uncategorized";
    if (!foodsGroupedByCategory[cat]) foodsGroupedByCategory[cat] = [];
    foodsGroupedByCategory[cat].push(item);
  });

  const handleContinueButton = () => {
    dispatch(setCredentials({ ...userInfo, selectedItems: selectedItems }));
    navigate("/bookingSummary");
  };

  const handleSelectSize = async ({ itemId, sizes }) => {
    setItemSizes({ ...itemSizes, [itemId]: sizes });
    if (!Object.keys(selectedItems).includes(itemId)) return;
    setSelectedItems({
      ...selectedItems,
      [itemId]: {
        ...selectedItems[itemId],
        itemSize: sizes?.sizeName,
        discountAmount:
          (sizes.itemPrice * sizes.discountPercent) / 100 +
          sizes.discountAmount,
        itemOfferPrice:
          sizes.itemPrice -
          ((sizes.itemPrice * sizes.discountPercent) / 100 +
            sizes.discountAmount),
        itemOriginalPrice: sizes.itemPrice,
        totalSellingPrice:
          selectedItems[itemId].selectedQuantity *
          (sizes.itemPrice -
            ((sizes.itemPrice * sizes.discountPercent) / 100 +
              sizes.discountAmount) +
            ((sizes.itemPrice -
              (sizes.itemPrice * sizes.discountPercent) / 100 +
              sizes.discountAmount) *
              (userInfo?.outletsDetails[0]?.separateGst
                ? selectedItems[itemId]?.gstPercent
                : 0)) /
              100),

        gstTax:
          selectedItems[itemId].selectedQuantity *
          (((sizes.itemPrice -
            (sizes.itemPrice * sizes.discountPercent) / 100 +
            sizes.discountAmount) *
            (userInfo?.outletsDetails[0]?.separateGst
              ? selectedItems[itemId]?.gstPercent
              : 0)) /
            100),
      },
    });
    dispatch(
      setCredentials({
        ...userInfo,
        selectedItems: {
          ...selectedItems,
          [itemId]: {
            ...selectedItems[itemId],
            itemSize: sizes.sizeName,
            discountAmount:
              (sizes.itemPrice * sizes.discountPercent) / 100 +
              sizes.discountAmount,
            itemOfferPrice:
              sizes.itemPrice -
              ((sizes.itemPrice * sizes.discountPercent) / 100 +
                sizes.discountAmount),
            itemOriginalPrice: sizes.itemPrice,
            totalSellingPrice:
              selectedItems[itemId].selectedQuantity *
              (sizes.itemPrice -
                ((sizes.itemPrice * sizes.discountPercent) / 100 +
                  sizes.discountAmount) +
                ((sizes.itemPrice -
                  (sizes.itemPrice * sizes.discountPercent) / 100 +
                  sizes.discountAmount) *
                  (userInfo?.outletsDetails[0]?.separateGst
                    ? selectedItems[itemId]?.gstPercent
                    : 0)) /
                  100),

            gstTax:
              selectedItems[itemId].selectedQuantity *
              (((sizes.itemPrice -
                (sizes.itemPrice * sizes.discountPercent) / 100 +
                sizes.discountAmount) *
                (userInfo?.outletsDetails[0]?.separateGst
                  ? selectedItems[itemId]?.gstPercent
                  : 0)) /
                100),
          },
        },
      })
    );
  };

  const addNewOutletItem = async (item) => {
    let selectedItemSizes;
    selectedItemSizes = item.availableSizes.find(
      (ai) => ai.sizeName === itemSizes[item._id]?.sizeName
    );
    const discountAmount =
      (selectedItemSizes?.itemPrice * selectedItemSizes?.discountPercent) /
        100 +
      selectedItemSizes?.discountAmount;
    const itemDetails = {
      itemId: item._id,
      itemName: item.itemName,
      itemSize: selectedItemSizes?.sizeName,
      selectedQuantity: 1,
      itemOfferPrice: selectedItemSizes?.itemPrice - discountAmount,
      discountAmount: discountAmount,
      itemOriginalPrice: selectedItemSizes?.itemPrice,
      gstPercent: userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0,
      totalSellingPrice:
        selectedItemSizes?.itemPrice -
        discountAmount +
        ((selectedItemSizes?.itemPrice - discountAmount) *
          (userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0)) /
          100,

      gstTax:
        ((selectedItemSizes?.itemPrice - discountAmount) *
          (userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0)) /
        100,
    };
    setSelectedItems({ [item._id]: itemDetails });
    dispatch(
      setCredentials({
        ...userInfo,
        selectedItems: { [item._id]: itemDetails },
      })
    );
  };

  const handleClearCart = async () => {
    await addNewOutletItem(newOuletItem);
  };

  return (
    <>
      <ReUsableModal
        title="foods already exist in cart from another restaurant"
        restrictTitle="Want to clear foods from cart and add this item ?"
        payload={[]}
        show={showModal}
        size="md"
        onHide={() => setShowModal(false)}
        onSubmit={handleClearCart}
        submit=" Yes "
        cancel=" No "
        submitDisabled={false}
        cancelDisabled={false}
        submitStyle={{
          backgroundColor: "green",
          color: "white",
          width: "3rem",
          height: "2rem",
          margin: "0rem 1rem",
        }}
        cancelStyle={{
          backgroundColor: "orange",
          color: "white",
          width: "3rem",
          height: "2rem",
          margin: "0rem 1rem",
        }}
      />
      <Row
        style={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "row",
          width: "70%",
          margin: "auto",
          textAlign: "center",
          // marginTop: "1rem",
          color: "black",
        }}
      >
        <Col style={{ color: "black" }}>
          <div className="home-heading">
            {/* <h1>{companyName}</h1> */}
            {!userInfo?.deliveryTo?.includes("undefined") && (
              <p>Seat - {userInfo?.deliveryTo}</p>
            )}
          </div>
        </Col>
        <Form.Control
          style={{
            height: "2.5rem",
            fontSize: "16px", // 👈 This prevents iOS zoom
          }}
          type="text"
          value={searchText}
          onChange={(e) => {
            const value = e.target.value;
            const txt = value.replace(/[^a-zA-Z\s]/g, "");
            setSearchText(txt);
          }}
          placeholder="Search by Food Name"
        />
      </Row>
      <Row
        className="food-group-scroll"
        style={{
          margin: "0.2rem 0rem",
          overflowX: "auto",
          whiteSpace: "nowrap",
          width: "96%",
        }}
      >
        <div>
          {foodCategoriesToList.map((cat) => (
            <Button
              style={{
                fontSize: "1rem",
                backgroundColor: "transparent",
                color: "rgb(17, 93, 102)",
                margin: "0.4rem",
                border: "solid 1px grey",
                borderRadius: "0.5rem",
              }}
              key={`scroll-btn-${cat}`}
              size="md"
              onClick={() => scrollToCategory(cat)}
            >
              {cat}
            </Button>
          ))}
        </div>
      </Row>

      <div
        style={{
          textAlign: "center",
          padding: "0.2rem 0rem 0.6rem 0rem",
          borderBottom: "0.5px solid",
        }}
      >
        {["All", "Veg", "Non-Veg"].map((type) => (
          <Button
            key={type}
            // variant={vegFilter === type ? "success" : "outline-secondary"}
            onClick={() => setVegFilter(type)}
            style={{
              margin: "0rem 0.3rem",
              padding: "0.3rem 1.2rem",
              fontSize: "0.80rem",
              borderRadius: "1rem",
              backgroundColor:
                vegFilter === type ? "rgb(17, 93, 102)" : "transparent",
              color: vegFilter === type ? "white" : "rgb(17, 93, 102)",
            }}
          >
            {type}
            {type === "All" ? (
              <></>
            ) : (
              <CgPlayStopR
                style={{
                  color: type === "Veg" ? "green" : "red",
                  marginLeft: "0.3rem",
                }}
              />
            )}
          </Button>
        ))}
      </div>

      {searchText?.length > 0 && (
        <h6 style={{ color: "red" }}>you are seeing searched foods now</h6>
      )}
      <div
        id="food-scroll-container"
        ref={scrollContainerRef}
        style={{
          height: "55vh",
          overflowY: "auto",
          padding: "0rem 0.5rem",
          borderBottom: "0.6px solid",
          marginBottom: "0.7rem",
        }}
      >
        {filteredFoods.length === 0 && (
          <div style={{ textAlign: "center", marginTop: "1rem", color: "red" }}>
            <strong>
              Items not available under this category, Please select another
              category
            </strong>
          </div>
        )}
        {error && (
          <div style={{ color: "red", textAlign: "center", marginTop: "5rem" }}>
            <p>
              {error?.data?.outletName + " " + error?.data?.error ||
                error?.error}
            </p>
          </div>
        )}
        {Object.entries(foodsGroupedByCategory)?.map(([category, items]) => (
          <div key={category} id={`section-${category}`}>
            <h6
              style={{
                color: "#555",
                marginTop: "0.1rem",
                textDecorationLine: "underline",
              }}
            >
              {category}
            </h6>

            {items?.map((ff) => (
              <>
                <Row
                  key={ff._id}
                  className="align-items-center mb-3"
                  style={{
                    borderBottom: "1px solid #ddd",
                    paddingBottom: "0.8rem",
                  }}
                >
                  {/* Food Image */}
                  <Col xs={3}>
                    <LazyMemberImage
                      foodItemId={ff._id}
                      imageUpdatedTimeFromDB={ff.imageUploadedTime}
                      currentlySelling={ff.currentlySelling}
                      photoUploaded={ff.imageUploaded}
                    />
                  </Col>
                  {/* Name & Price */}
                  <Col xs={5}>
                    <div style={{ fontWeight: "bold" }}>
                      {ff.itemName}{" "}
                      {ff.isVeg ? (
                        <CgPlayStopR
                          style={{ color: "green", width: "0.6rem" }}
                        />
                      ) : (
                        <CgPlayStopR
                          style={{ color: "red", width: "0.6rem" }}
                        />
                      )}
                    </div>
                    <div style={{ color: "gray", fontSize: "0.9rem" }}>
                      {ff.localName}
                      {ff.itemDescription && (
                        <OverlayTrigger
                          trigger="click"
                          rootClose
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-${ff._id}`}>
                              {ff.itemDescription}
                            </Tooltip>
                          }
                        >
                          <span
                            style={{ marginLeft: "0.5rem", cursor: "pointer" }}
                          >
                            <BsFillInfoCircleFill />
                          </span>
                        </OverlayTrigger>
                      )}
                    </div>
                    <br />
                    <span style={{ marginTop: "0.1rem", fontWeight: "500" }}>
                      {(ff.availableSizes.find(
                        (ai) => ai.sizeName === itemSizes[ff._id]?.sizeName
                      )?.discountPercent > 0 ||
                        ff.availableSizes.find(
                          (ai) => ai.sizeName === itemSizes[ff._id]?.sizeName
                        )?.discountAmount > 0) && (
                        <span
                          style={{
                            textDecoration: "line-through",
                            marginRight: "0.2rem",
                          }}
                        >
                          ₹
                          {
                            ff.availableSizes.find(
                              (ai) =>
                                ai.sizeName === itemSizes[ff._id]?.sizeName
                            )?.itemPrice
                          }
                        </span>
                      )}
                      <span>
                        ₹
                        {ff.availableSizes.find(
                          (ai) =>
                            ai.sizeName ===
                            (selectedItems[ff._id]?.itemSize
                              ? selectedItems[ff._id]?.itemSize
                              : itemSizes[ff._id]?.sizeName)
                        )?.itemPrice -
                          (ff.availableSizes.find(
                            (ai) =>
                              ai.sizeName ===
                              (selectedItems[ff._id]?.itemSize
                                ? selectedItems[ff._id]?.itemSize
                                : itemSizes[ff._id]?.sizeName)
                          )?.itemPrice *
                            ff.availableSizes.find(
                              (ai) =>
                                ai.sizeName ===
                                (selectedItems[ff._id]?.itemSize
                                  ? selectedItems[ff._id]?.itemSize
                                  : itemSizes[ff._id]?.sizeName)
                            )?.discountPercent) /
                            100 -
                          ff.availableSizes.find(
                            (ai) =>
                              ai.sizeName ===
                              (selectedItems[ff._id]?.itemSize
                                ? selectedItems[ff._id]?.itemSize
                                : itemSizes[ff._id]?.sizeName)
                          )?.discountAmount}
                      </span>{" "}
                      {/* {ff.availableSizes?.length > 1 && (
                        <small
                          href=""
                          onClick={(e) => handleClickSize(ff)}
                          style={{
                            color: "green",
                            textDecoration: "underline",
                          }}
                        >
                          {
                            itemSizes[Object.keys(itemSizes).find((key) => key)]
                            // Object.keys(itemSizes).find((key) => 1)
                          }
                        </small>
                      )} */}
                      {ff.itemQuantity <
                        ff.availableSizes.find(
                          (ai) => ai.sizeName === itemSizes[ff._id]?.sizeName
                        )?.consumptionQty *
                          10 &&
                        ff.itemQuantity > 0 && (
                          <small style={{ color: "red" }}>
                            only{" "}
                            {Math.floor(
                              ff.itemQuantity /
                                ff.availableSizes.find(
                                  (ai) =>
                                    ai.sizeName === itemSizes[ff._id]?.sizeName
                                )?.consumptionQty
                            )}{" "}
                            left
                          </small>
                        )}
                    </span>{" "}
                  </Col>
                  {/* Quantity Controls */}
                  <Col
                    xs={4}
                    className="d-flex align-items-center justify-content-end"
                  >
                    {selectedItems[ff._id]?.selectedQuantity > 0 ? (
                      <div
                        className="d-flex align-items-center"
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "0.5rem",
                          padding: "0.2rem 0.5rem",
                          backgroundColor: "rgb(17, 93, 102)",
                          color: "white",
                          fontSize: "1.1rem",
                        }}
                      >
                        <span
                          style={{
                            margin: "0.3rem 0.6rem",
                            fontSize: "1.6rem",
                          }}
                          onClick={() => decreaseselectedItems(ff)}
                        >
                          <strong>-</strong>
                        </span>
                        <span style={{ margin: "0 0.5rem" }}>
                          <strong>
                            {selectedItems[ff._id]?.selectedQuantity}
                          </strong>
                        </span>
                        <span
                          style={{
                            margin: "0.3rem 0.6rem",
                            fontSize: "1.6rem",
                          }}
                          onClick={() =>
                            selectedItems[ff._id].selectedQuantity *
                              ff?.availableSizes?.find(
                                (ai) =>
                                  ai.sizeName ===
                                  selectedItems[ff._id]?.itemSize
                              )?.consumptionQty +
                              ff?.availableSizes?.find(
                                (ai) =>
                                  ai.sizeName ===
                                  selectedItems[ff._id]?.itemSize
                              )?.consumptionQty <=
                              ff.itemQuantity && increaseselectedItems(ff)
                          }
                        >
                          <strong>+</strong>
                        </span>
                      </div>
                    ) : (
                      <Button
                        disabled={
                          ff?.itemQuantity <= 0 ||
                          !(
                            Number(
                              new Date().getHours() +
                                "." +
                                new Date().getMinutes()
                            ) >= userInfo?.outletsDetails[0]?.openingHour &&
                            Number(
                              new Date().getHours() +
                                "." +
                                new Date().getMinutes()
                            ) < userInfo?.outletsDetails[0]?.closingHour
                          ) ||
                          !userInfo?.outletsDetails[0].openedDays.includes(
                            getNameOfTheDay(new Date().getDay())
                          ) ||
                          !userInfo?.outletsDetails[0]?.currentlyOpen
                        }
                        style={{
                          width: "5rem",
                          height: "2rem",
                          fontSize: "1rem",
                          backgroundColor: "rgb(17, 93, 102)",
                        }}
                        onClick={() => handleAddCheck(ff)}
                      >
                        Add
                      </Button>
                    )}
                  </Col>
                  {ff.availableSizes?.length > 1 && (
                    // <div>
                    //   {ff.availableSizes?.map((ai) => (
                    //     <li>{ai.sizeName}</li>
                    //   ))}
                    // </div>

                    <div className="vertical-radio-group">
                      {ff.availableSizes?.map((option) => (
                        <Form.Check
                          style={{ margin: "0.6rem 5rem" }}
                          key={option.sizeName}
                          type="radio"
                          label={
                            <span style={{ color: "rgb(17, 93, 102)" }}>
                              {option.sizeName} - {option.sizeDescription} - ₹{" "}
                              {option?.itemPrice -
                                (option?.itemPrice * option?.discountPercent ||
                                  0) /
                                  100 -
                                (option?.discountAmount || 0)}{" "}
                            </span>
                          }
                          name={`platRadio-${ff._id}${option.sizeName}`}
                          id={`platRadio-${ff._id}${option.sizeName}`}
                          value={option.sizeName}
                          checked={
                            selectedItems[ff._id]?.itemSize === option.sizeName
                          }
                          onChange={(e) =>
                            handleSelectSize({
                              itemId: ff._id,
                              sizes: option,
                            })
                          }
                        />
                      ))}
                    </div>
                  )}
                </Row>
              </>
            ))}
          </div>
        ))}
      </div>

      <Row className="align-items-center">
        <Col>
          <span style={{ color: "rgb(17, 93, 102)" }}>Food Items in Cart</span>
          <br />
          <br />
          <strong style={{ fontSize: "1.2rem" }}>
            Total ₹
            {selectedItems &&
              Object.values(selectedItems)
                ?.reduce(
                  (total, it) =>
                    total + Number(it.itemOfferPrice) * it.selectedQuantity,
                  0
                )
                .toFixed(2)}{" "}
            |{" "}
            {selectedItems &&
              Object.values(selectedItems)?.reduce(
                (total, it) => total + Number(it.selectedQuantity),
                0
              )}{" "}
            Items{" "}
          </strong>{" "}
        </Col>
        <Col xs="auto">
          <Button
            disabled={selectedItems && Object.values(selectedItems)?.length < 1}
            style={{
              fontSize: "1rem",
              padding: "0.8rem",
              backgroundColor: "rgb(47, 177, 197)",
              color: "black",
            }}
            className="continue-btn"
            onClick={(e) => handleContinueButton()}
          >
            <strong>CONTINUE</strong>
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default FoodsListScreen;
